import { html, TemplateResult, LitElement } from 'lit';
import { customElement, queryAssignedElements } from 'lit/decorators.js';
import globalStyles from './styles/outline-image-gallery-block.global.pcss?inline';
import encapsulatedStyles from './styles/outline-image-gallery-block.encapsulated.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { validateSlot } from '../../utilities/slot';

@customElement('outline-image-gallery-block')
export class OutlineImageGalleryBlock extends LitElement {

    @queryAssignedElements({slot: 'heading'})
    headingItems: Array<HTMLElement>;

    @queryAssignedElements({slot: 'description'})
    descriptionItems: Array<HTMLElement>;

    adoptedStyleSheets = new AdoptedStyleSheets(this, {
        globalCSS: globalStyles,
        encapsulatedCSS: encapsulatedStyles,
    });

    firstUpdated() {
        const headingItems: Array<HTMLElement> = [...this.headingItems, ...this.descriptionItems];
        validateSlot(headingItems, '.heading-section', this.shadowRoot);
    }

    render(): TemplateResult {
        return html`
        <div class="heading-section">
            <slot name="heading"></slot>
            <slot name="description"></slot>
        </div>
        <div class="image-gallery-block">
            <slot></slot>
        </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'outline-image-gallery-block': OutlineImageGalleryBlock;
    }
}
